import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.FindHelpers;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "FindHelpers.Phaser.IntroductionScene.1",
            "FindHelpers.Phaser.IntroductionScene.2",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/FindHelpersGame/scenes/GameIntro.ts